// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Shared
import { PublicFooterComponent } from 'src/app/modules/public/components/public-footer/public-footer.component';
import { PublicHeaderComponent } from 'src/app/modules/public/components/public-header/public-header.component';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,
  ],
  declarations: [
    // Shared components
    PublicHeaderComponent,
    PublicFooterComponent,
  ],
  exports: [
    // Shared components
    PublicHeaderComponent,
    PublicFooterComponent,
  ]
})
export class PublicModule { }
